import { CaseTypeCase, EventBase } from "@vp/models";

export interface NewCaseNotification {
  caseId: string;
  caseType: CaseTypeCase;
}

export class NewCaseEvent extends EventBase<NewCaseNotification> {
  constructor(newCase: NewCaseNotification) {
    super();
    this.args = newCase;
  }
}
